
import Vue from "vue";
import Component from "vue-class-component";

@Component<SmallHeading>({})
export default class SmallHeading extends Vue {}
